import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, TvMinimal } from "lucide-react";
import api from "@/lib/api";

// Public shortcode embed: /embed/church/:code -> resolves to the linked playlist embed.
export default function ChurchEmbed() {
  const { code } = useParams();
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/public/church-embed/${code}`);
        if (data.playlist_id && data.owner_id) {
          window.location.replace(`/embed/library/${data.owner_id}?playlist=${encodeURIComponent(data.playlist_id)}&code=${encodeURIComponent(code)}`);
        } else {
          setError("This church code doesn't have a playlist linked yet.");
        }
      } catch {
        setError("Church code not found.");
      }
    })();
  }, [code]);

  return (
    <div className="min-h-screen bg-[#0B1120] text-white flex items-center justify-center p-6" data-testid="church-embed-page">
      {error ? (
        <div className="text-center">
          <TvMinimal className="mx-auto h-8 w-8 text-gray-600" />
          <p className="mt-3 text-gray-400 text-sm" data-testid="church-embed-error">{error}</p>
        </div>
      ) : (
        <Loader2 className="h-6 w-6 text-amber-400 animate-spin" />
      )}
    </div>
  );
}
